import { render, staticRenderFns } from "./Productos.vue?vue&type=template&id=26f9c823&lang=pug"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"
import style0 from "./Productos.vue?vue&type=style&index=0&id=26f9c823&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports